import { render, staticRenderFns } from "./IssueInvoice.vue?vue&type=template&id=20f96096&scoped=true"
import script from "./IssueInvoice.vue?vue&type=script&lang=js"
export * from "./IssueInvoice.vue?vue&type=script&lang=js"
import style0 from "./IssueInvoice.vue?vue&type=style&index=0&id=20f96096&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f96096",
  null
  
)

export default component.exports